import { AuctionState } from '../const'

export const hasAuctionEnded = (auctionState: AuctionState) => {
  return (
    auctionState === AuctionState.Ended ||
    auctionState === AuctionState.Canceled
  )
}
